"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const CloseButton_1 = __importDefault(require("~/components/common/controls/CloseButton"));
const redux_1 = require("redux");
const react_redux_1 = require("react-redux");
const action_1 = require("~/store/account/action");
const ContentListModalLoader_1 = require("../ContentListModalLoader");
const ContentListModalHeadline_module_scss_1 = __importDefault(require("./ContentListModalHeadline.module.scss"));
function ContentListModalHeadline({ headline }) {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { dispatchSetCurrentTabId } = (0, redux_1.bindActionCreators)({ dispatchSetCurrentTabId: action_1.setCurrentTabId }, (0, react_redux_1.useDispatch)());
    const closeHandler = () => {
        navigate(-1);
        dispatchSetCurrentTabId(undefined);
    };
    return (react_1.default.createElement("div", { className: ContentListModalHeadline_module_scss_1.default.headline },
        react_1.default.createElement("div", { className: ContentListModalHeadline_module_scss_1.default.content }, headline !== null && headline !== void 0 ? headline : react_1.default.createElement(ContentListModalLoader_1.ContentListModalHeadlineLoader, null)),
        react_1.default.createElement(CloseButton_1.default, { onCLickHandler: closeHandler })));
}
exports.default = ContentListModalHeadline;
